const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6 6.36a1.12 1.12 0 0 0-1.08-.87h-11a1.12 1.12 0 0 0-1.08.87l-.86 3.91a2.1 2.1 0 0 0 1 1.79v5.32a1.1 1.1 0 0 0 1.1 1.1H17.4a1.1 1.1 0 0 0 1.1-1.1v-5.32a2.08 2.08 0 0 0 1-1.76zM8.11 10.28a1.47 1.47 0 0 1-2.94 0L6 6.49a.47.47 0 0 1 .46-.37h2.17zm3.58 0a1.48 1.48 0 0 1-2.95 0l.52-4.2h2.43zm.62 0V6.12h2.43l.52 4.2a1.48 1.48 0 0 1-2.95 0zm2.81 6.75a1.76 1.76 0 1 1 0-3.51 1.69 1.69 0 0 1 1.18.48l-.48.46a1 1 0 0 0-.7-.28 1.11 1.11 0 0 0 0 2.22 1 1 0 0 0 1-.75h-1V15h1.66a2.36 2.36 0 0 1 0 .29 1.62 1.62 0 0 1-1.66 1.76zm2.24-5.27a1.48 1.48 0 0 1-1.47-1.48l-.52-4.16h2.15a.47.47 0 0 1 .46.37l.85 3.84a1.47 1.47 0 0 1-1.47 1.45z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmb);
export default __webpack_public_path__ + "static/media/gmb.89b2a759e9ddbc6fb159a56868a288eb.svg";
export { ForwardRef as ReactComponent };